import { render, staticRenderFns } from "./ModattaIndividualsCallToAction.vue?vue&type=template&id=160d0004"
import script from "./ModattaIndividualsCallToAction.vue?vue&type=script&lang=js"
export * from "./ModattaIndividualsCallToAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports